import * as React from "react";
import { connect } from "react-redux";
import { selectCoopCanInvite, selectCoopCanKick, selectCoopCanPromoteDemote, selectCoopCanPromoteDemoteSelf, selectCoopIsMemberSameCoop, selectCoopRole, } from "../../selectors/selectCoopInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdCoopRole } from "../cooperative/info-view/IdCoopRole";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
import { PlayerProfileSmallButton } from "./PlayerProfileSmallButton";
export var _PlayerProfilePersonalButtons = function (_a) {
    var playerId = _a.playerId, playerIsInCoop = _a.playerIsInCoop, onSettingsClick = _a.onSettingsClick, onVisitClick = _a.onVisitClick, onInviteToCoopClick = _a.onInviteToCoopClick, onPromoteClick = _a.onPromoteClick, onKickClick = _a.onKickClick, canVisitPlayer = _a.canVisitPlayer, canInviteToCoop = _a.canInviteToCoop, canPromotePlayer = _a.canPromotePlayer, canKickPlayer = _a.canKickPlayer, coopRole = _a.coopRole;
    if (playerId === undefined) {
        return (React.createElement(TooltipText, { id: IdLoca.settingsMenu_category1, anchor: IdTooltipAnchor.Bottom },
            React.createElement(PlayerProfileSmallButton, { icon: IdIcon.PlayerSettingsIcn, onClick: onSettingsClick })));
    }
    var buttonsConfig = [
        {
            disabled: !canVisitPlayer,
            icon: IdIcon.FarmNameIcn,
            onClick: onVisitClick,
        },
    ];
    if (!playerIsInCoop) {
        buttonsConfig.push({
            disabled: !canInviteToCoop,
            icon: IdIcon.CoopInviteIcn,
            onClick: onInviteToCoopClick,
            tooltipLoca: canInviteToCoop
                ? IdLoca.invite
                : IdLoca.floatingText_leadersAndDeputiesOnly,
        });
    }
    else if (coopRole !== IdCoopRole.Leader) {
        buttonsConfig.push({
            disabled: !canPromotePlayer,
            icon: coopRole === IdCoopRole.Deputy
                ? IdIcon.AllianceDeputyIcn
                : IdIcon.AllianceMemberIcn,
            onClick: onPromoteClick,
            tooltipLoca: canPromotePlayer
                ? IdLoca.tooltip_selectMember_web
                : IdLoca.floatingText_leadersAndDeputiesOnly,
        }, {
            disabled: !canKickPlayer,
            icon: IdIcon.KickIcn,
            onClick: onKickClick,
            tooltipLoca: canKickPlayer
                ? IdLoca.tooltip_kickMember_web
                : IdLoca.floatingText_leadersAndDeputiesOnly,
        });
    }
    return (React.createElement(React.Fragment, null, buttonsConfig.map(function (buttonConfig, index) {
        var btnDOM = (React.createElement("div", { className: "player-profile__small-btn", key: "pp-btn-" + index },
            React.createElement(PlayerProfileSmallButton, { onClick: buttonConfig.onClick, disabled: buttonConfig.disabled, icon: buttonConfig.icon })));
        if (!buttonConfig.tooltipLoca) {
            return btnDOM;
        }
        return (React.createElement(TooltipText, { id: buttonConfig.tooltipLoca, anchor: IdTooltipAnchor.Bottom, key: "pp-btnToolTip-" + index }, btnDOM));
    })));
};
var mapState = function (state, ownProps) { return ({
    canInviteToCoop: ownProps.playerId ? selectCoopCanInvite(state, ownProps.playerId) : false,
    canKickPlayer: ownProps.playerId ? selectCoopCanKick(state, ownProps.playerId) : false,
    canPromotePlayer: ownProps.playerId
        ? selectCoopCanPromoteDemote(state, ownProps.playerId)
        : selectCoopCanPromoteDemoteSelf(state),
    canVisitPlayer: false,
    coopRole: selectCoopRole(state, ownProps.playerId),
    getOtherPlayerButtonsId: function (playerId) { return []; },
    playerIsInCoop: ownProps.playerId
        ? selectCoopIsMemberSameCoop(state, ownProps.playerId)
        : false,
}); };
var mapDispatch = function (dispatch) { return ({
    onInviteToCoopClick: function () { return dispatch(actionModalOpen(IdModal.CoopInvite)); },
    onKickClick: function () { return dispatch(actionModalOpen(IdModal.CoopKick)); },
    onPromoteClick: function () { return dispatch(actionModalOpen(IdModal.CoopRoleManagement)); },
    onSettingsClick: function () { return dispatch(actionModalOpen(IdModal.Settings)); },
    onVisitClick: function () {
        return;
    },
}); };
export var PlayerProfilePersonalButtons = connect(mapState, mapDispatch)(_PlayerProfilePersonalButtons);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/PlayerProfilePersonalInfoButtons.tsx
// module id = 2880
// module chunks = 3